// extracted by mini-css-extract-plugin
export default {"label":"Upload_label__V78S6","p":"Upload_p__FjUt3","img":"Upload_img__tbM5y"};